/* global document, MutationObserver, window */
import hoverintent from 'hoverintent';
import map from 'lodash/fp/map';

/**
 * Main menu hovers, accessibility.
 */

export function mainMenu() {

	const siteNavigation = document.getElementById( 'site-navigation' );
	if ( ! siteNavigation ) {
		return;
	}
  const button = siteNavigation.getElementsByTagName('button')[0];
  if ('undefined' === typeof button) {
    return;
  }
  const menu = siteNavigation.getElementsByTagName('ul')[0];
  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }
  if (!menu.classList.contains('nav-menu')) {
    menu.classList.add('nav-menu');
  }

	const mobileToggle = siteNavigation.getElementsByTagName( 'button' )[ 0 ];
	if ( 'undefined' === typeof mobileToggle ) {
		return;
	}

  mobileToggle.addEventListener( 'click', toggleMobileMenu, false );
  document.addEventListener('click', handleClickMenuClose, false);
  const mainMenu = document.querySelector('#primary-menu');

  // Main menu hovers and keyboard accessibility
  const dropdowns = document.querySelectorAll('.main-navigation .dropdown');
  map((item) => {
    const trigger = item.querySelector('.dropdown-toggle');
    const topLevel = item.querySelector('.nav-link');
    const menu = item.querySelector('.dropdown-menu');
    const links = menu.querySelectorAll('a');
    const hideMenu = () => {
      menu.classList.remove('show');
      menu.parentNode.classList.remove('show');
      trigger.setAttribute('aria-expanded', 'false');
      mainMenu.classList.remove('sub-menu-open');
    };
    const showMenu = () => {
      menu.classList.add('show');
      menu.parentNode.classList.add('show');
      trigger.setAttribute('aria-expanded', 'true');
      mainMenu.classList.add('sub-menu-open');
      map((dropdown) => {
        if (dropdown !== item) {
          dropdown.querySelector('.dropdown-toggle').blur();
        }
      }, dropdowns);
    };

    // Enable click or hover based on screen size
    const mediaQueryList = window.matchMedia('(max-width: 1024px)');
    mediaQueryList.addEventListener('change', handleSizeChange);
    handleSizeChange(mediaQueryList);

    let clickHandler; // Store reference to the click event handler
    let hoverInstance; // Store reference to hoverIntent instance

    function handleSizeChange(mql) {
      if (mql.matches) {
        // Remove hoverIntent if it was previously applied
        if (hoverInstance) {
          hoverInstance.remove();
          hoverInstance = null;
        }

        // Enable click behavior
        clickHandler = function (evt) {
          if (menu.classList.contains('show')) {
            hideMenu();
          } else {
            showMenu();
          }
          evt.stopPropagation();
        };

        trigger.addEventListener('click', clickHandler);
      } else {
        // Remove click event listener if it exists
        if (clickHandler) {
          trigger.removeEventListener('click', clickHandler);
          clickHandler = null;
        }

        // Enable hover behavior
        hoverInstance = hoverintent(item, showMenu, hideMenu);
      }
    }

    // Expand dropdown on enter, space, or down arrow
    trigger.addEventListener('keydown', (evt) => {
      switch (evt.keyCode) {
        case 13:
        case 32:
          showMenu();
          evt.stopPropagation();
          evt.preventDefault();
          break;
        case 38: {
          showMenu();
          evt.stopPropagation();
          evt.preventDefault();
          const menuItems = menu.querySelectorAll('a');
          const last = menuItems[menuItems.length - 1];
          last.setAttribute('tabindex', '-1');
          if (menuItems) {
            setTimeout(() => {
              $(last).focus();
              last.removeAttribute('tabindex');
            }, 50);
          }
          break;
        }
        case 40: {
          showMenu();
          evt.stopPropagation();
          evt.preventDefault();
          const first = menu.querySelector('a');
          //first.setAttribute('tabindex', '-1');
          if (first) {
            setTimeout(() => {
              $(first).focus();
              first.removeAttribute('tabindex');
            }, 50);
          }
          break;
        }
        default:
          break;
      }
    });
    // Collapse dropdown on ESC and refocus triggering element
    item.addEventListener('keydown', (evt) => {
      switch (evt.keyCode) {
        case 27:
          hideMenu();
          trigger.focus();
          break;
        default:
          break;
      }
    });
    // When a trigger is focused, collapse any dropdown menus that aren't
    // in the same dropdown container. I.e. when tabbing forward to the
    // next top level menu item.
    topLevel.addEventListener('focus', () => {
      map((dropdown) => {
        if (dropdown !== item) {
          const m = dropdown.querySelector('.dropdown-menu');
          m.classList.remove('show');
          m.parentNode.classList.remove('show');
          dropdown.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
        }
      }, dropdowns);
    });
    // Handle arrow navigation on links within dropdowns.
    links.forEach((link, index) => {
      link.addEventListener('keydown', (evt) => {
        switch (evt.keyCode) {
          case 40:
            $('a', $(evt.target).closest('.dropdown-menu')).eq(index + 1).focus();
            break;
          case 38: {
            $('a', $(evt.target).closest('.dropdown-menu')).eq(index - 1).focus();
            if (index === 0) {
              hideMenu();
              trigger.focus();
            }
            break;
          }
          case 37: {
            const $prev = $(evt.target).closest('.dropdown').prev('.dropdown').find('.dropdown-toggle');
            if ($prev.length) {
              $prev.focus();
            } else {
              hideMenu();
              document.querySelector('a.navbar-brand').focus();
            }
            break;
          }
          case 39: {
            const $next = $(evt.target)
              .closest('.dropdown')
              .next('.dropdown')
              .find('.dropdown-toggle');
            if ($next.length) {
              $next.focus();
            } else {
              $(evt.target)
                .closest('.dropdown')
                .next('.nav-item')
                .find('a.menu-level-0')
                .focus();
            }
            break;
          }
          default:
            break;
        }
      });
    });
    // When gaining focus on a top level link collapse the menu. I.e.
    // when tabbing forward to the next top level item that is not a
    // dropdown.
    document.querySelector('a.menu-level-0').addEventListener('focus', hideMenu);
    // Arrow key navigation on top level menu items
    const topLevelLinks = document.querySelectorAll('.menu-level-0');
    map((link) => {
      link.addEventListener('keydown', (evt) => {
        switch (evt.keyCode) {
          case 37:
            $(evt.target)
              .closest('.nav-item')
              .prev('.nav-item')
              .find('.menu-level-0')
              .focus();
            break;
          case 39:
            $(evt.target)
              .closest('.nav-item')
              .next('.nav-item')
              .find('.menu-level-0')
              .focus();
            break;
          default:
            break;
        }
      });
    }, topLevelLinks);
  }, dropdowns);

	/**
	 * Button open/close event listener.
	 * Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	 */
	function toggleMobileMenu() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}
  }

  /**
   * Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
   */
  function handleClickMenuClose(event) {
    const isClickInside = siteNavigation.contains(event.target);
    if (!isClickInside) {
      siteNavigation.classList.remove('toggled');
      button.setAttribute('aria-expanded', 'false');
    }
  }
}
